import React from "react";
import "./Table.css";
import { injectIntl } from "react-intl";

export const Table = React.forwardRef(({ children }, ref) => {
  return (
    <table ref={ref} className="responsiveTable" aria-live="polite">
      {children}
    </table>
  );
});

export const TableHead = ({ children, sortColumn, sortDirection, updateSort }) => {
  return (
    <thead>
      <tr>
        {React.Children.map(children, child =>
          child.type === HeaderCell
            ? React.cloneElement(child, {
                sortColumn,
                sortDirection,
                updateSort,
              })
            : child
        )}
      </tr>
    </thead>
  );
};

export const HeaderCell = ({
  children,
  name,
  sortColumn,
  sortDirection,
  updateSort,
  className,
  disabled,
  ...rest
}) => {
  const onSortClick = () => {
    updateSort(name);
  };
  const sortIcon =
    sortColumn === name ? (
      <i className={sortDirection === "asc" ? "sortAsc" : "sortDesc"} />
    ) : (
      <i className='sortPlaceholder' />
    );
  return (
    <th>
      {!disabled && (
        <button
          type="button"
          className={"headerCell " + className}
          onClick={onSortClick}
          {...rest}
        >
          {children} {sortIcon}
        </button>
      )}
    </th>
  );
};

export const TableBody = ({ children, rows }) => {
  return <tbody>{children(rows)}</tbody>;
};

export const Column = ({ children, label, className, ...rest }) => {
  return (
    <td data-label={label} className={className} {...rest}>
      {children}
    </td>
  );
};

const LocalizedCol = props => {
  const localizedLabel = props.label
    ? props.intl.formatMessage({ id: props.label })
    : props.rawLabel;
  return <Column {...props} label={localizedLabel} />;
};

export const Col = injectIntl(LocalizedCol);



// WEBPACK FOOTER //
// ./src/components/Table.js